import React, { Component } from 'react';
import classNames from 'classnames';

if (process.env.NODE_ENV !== 'test') {
  require('./Component.scss');
}

export default class ComponentBody extends Component {
  render() {
    return (
      <div className={classNames('ComponentBody', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}
